import TheGrid from '@/views/membershiptypes/grid'
import Edit from '@/views/membershiptypes/edit'
import TheView from '@/views/membershiptypes/view'

export default {
  path: '/membershiptypes',
  redirect: '/membershiptypes/index',
  name: 'membershiptypes',
  meta: {
    auth: {
      redirect: {
        name: 'membershiptypes.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Tipos de Sócio'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'membershiptypes.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'membershiptypes.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'membershiptypes.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'membershiptypes.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
